import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Airport from '../entities/flight/airport'

import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'


interface AirportState extends ListState<Airport>{
    airport:Airport,
    editAirport:Airport,


}

class AirportMutations extends ListMutations<Airport>{

}

class AirportModule extends ListModule<AirportState,any,Airport>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Airport>(),
        loading:false,
        editAirport:new Airport(),
        selectAirport:new Airport(),
    
    
    }
    actions = {
        async selectAirport(
            context: ActionContext<AirportState, any>,
            payload: any
          ) {
            context.state.editAirport = payload.data;
          },
          
        async saveAirport(
          context: ActionContext<AirportState, any>,
          payload: any
        ) {
          let reponse = await Ajax.post(
            "/api/services/app/Flight/SaveAirport",
            payload.data
          );
    
          let page = reponse.data.result as PageResult<Airport>;
          context.state.totalCount = page.totalCount;
          context.state.list = page.items;
        },
        async updateAirport(
          context: ActionContext<AirportState, any>,
          payload: any
        ) {
          let reponse = await Ajax.put(
            "/api/services/app/Flight/UpdateAirport",
            payload.data
          );
    
          let page = reponse.data.result as PageResult<Airport>;
          context.state.totalCount = page.totalCount;
          context.state.list = page.items;
        },
        async getAirports(
          context: ActionContext<AirportState, any>,
          payload: any
        ) {
          // context.state.loading=true;
          let reponse = await Ajax.get(
            "/api/services/app/Flight/GetAirports",
            payload.data
          );
    
          // context.state.loading=false;
          let page = reponse.data.result as PageResult<Airport>;
          context.state.totalCount = page.totalCount;
          context.state.list = page.items;
        },
        async deleteAirport(
          context: ActionContext<Airport, any>,
          payload: any
        ) {
          await Ajax.delete(
            "/api/services/app/Flight/DeleteAirport?input=" +
              payload.payload
          );
        },
      };
    

    mutations={
        setCurrentPage(state:AirportState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:AirportState,pagesize:number){
            state.pageSize=pagesize;
        },
       
    }
}
const airportModule=new AirportModule();
export default airportModule;